import React from 'react';
import PropTypes from 'prop-types';
import { Modal as ReactModal } from 'reactstrap';
import {ModalBody, ModalFooter, ModalFooterButtons, ModalHeader } from './index';
import './modal.scss';

export const Modal = ({
    alignFooter ="center",
    alignText = "center",
    backdrop,
    branded = false,
    className,
    icon,
    isOpen,
    modalHeader,
    modalBody,
    modalFooter,
    modalFooterButtons,
    onCloseClick,
    onOpened = () => ({}),
    toggle
}) => {

    const modalClasses = [
        `${alignText ? `bsw-modal-align--${alignText}` : ''}`,
        `${branded ? 'bsw-modal--branded' : ''}`,
        `${(modalFooter || modalFooterButtons) ? 'bsw-modal-with-footer' : ''}`,
        `${className ? className : ''}`,
    ].join(' ');

    return (<ReactModal
        backdrop={backdrop ? backdrop : true}
        centered
        isOpen={isOpen}
        onOpened={onOpened}
        modalClassName={modalClasses}
        toggle={toggle ? () => toggle() : () => ({})}
        wrapClassName="bsw-modal"
    >
        {(modalHeader || branded || icon || onCloseClick) &&
            <ModalHeader
                alignText={alignText}
                icon={icon || null}
                onCloseClick={onCloseClick ? onCloseClick : null}
                branded={branded}
            >
                {modalHeader || null}
            </ModalHeader>
        }
        {modalBody &&
            <ModalBody
                alignText={alignText}
                branded={branded}
            >
                {modalBody}
            </ModalBody>
        }
        {modalFooter &&
            <ModalFooter
                align={alignFooter}
            >
                {modalFooter}
            </ModalFooter>
        }
        {modalFooterButtons &&
            <ModalFooterButtons
                align={alignFooter}
                branded={branded}
                buttons={modalFooterButtons}
            />
        }
    </ReactModal>
    );
}
